import { render, staticRenderFns } from "./SlideProduct.vue?vue&type=template&id=f0603e14&scoped=true&"
import script from "./SlideProduct.vue?vue&type=script&lang=js&"
export * from "./SlideProduct.vue?vue&type=script&lang=js&"
import style0 from "./SlideProduct.vue?vue&type=style&index=0&id=f0603e14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0603e14",
  null
  
)

export default component.exports